import { render, staticRenderFns } from "./loginProvee.vue?vue&type=template&id=0ff02a75&scoped=true"
import script from "./loginProvee.vue?vue&type=script&lang=js"
export * from "./loginProvee.vue?vue&type=script&lang=js"
import style0 from "./loginProvee.vue?vue&type=style&index=0&id=0ff02a75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff02a75",
  null
  
)

export default component.exports